module.exports = __webpack_public_path__ + "bb25a739ed8cb7e709ed999985554988.pdf";